export default __webpack_public_path__ + "static/media/215.1017682f.jpg";